import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Link,
} from '@material-ui/core';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: '0 5px',
    },
  },
}));

function date(s) {
  const tmp = new Date(s);
  return tmp.toLocaleDateString('en-US');
}

function time(s) {
  const tmp = new Date(s);
  return tmp.toLocaleTimeString('en-US');
}

export default function PlayersTable(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selected, setSelected] = React.useState(null);
  const players = props.data;

  const handleClick = (event, id) => {
    setSelected(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
          <Checkbox
            indeterminate={props.numSelected > 0 && props.numSelected < props.rowCount}
            checked={props.rowCount > 0 && props.numSelected === props.rowCount}
            onChange={props.onSelectAllClick}
            disabled={(players.length === 0)}
            inputProps={{ 'aria-label': 'select all players' }}
          />
          </TableCell>
          <TableCell align="right">id</TableCell>
          <TableCell align="right">Address</TableCell>
          <TableCell align="right">Name</TableCell>
          <TableCell align="right">Email</TableCell>
          <TableCell align="right">Avatar</TableCell>
          <TableCell align="right">Type</TableCell>
          <TableCell align="right">Visits</TableCell>
          <TableCell align="right">Created</TableCell>
          <TableCell align="right"></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
      {
      (players.length !== 0)
        ? props.data.map((player, index) => {
          //
          const isItemSelected = props.isSelected(player.id);
          //
          const url = (process.env.INFURA_NETWORK === 'ropsten') ? 'ropsten.etherscan.io' : 'etherscan.io';
          //
          return (
          <TableRow
            key={index}
            hover
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            <TableCell padding="checkbox">
              <Checkbox
                  checked={isItemSelected}
                  inputProps={{ 'aria-labelledby': index }}
                  onChange={(event) => props.handleRowClick(event, player.id)}
              />
            </TableCell>
            <TableCell align="right">{player.id}</TableCell>
            <TableCell align="right">
              <Link color="primary" href={`https://${url}/address/${player.publicAddress}`} target="_blank">
                {`${player.publicAddress.slice(0, 6)}...${player.publicAddress.slice(38)}`}
              </Link>
            </TableCell>
            <TableCell align="right">{player.name}</TableCell>
            <TableCell align="right">{(player.email) ? player.email : '-'}</TableCell>
            <TableCell align="right">{player.avatar}</TableCell>
            <TableCell align="right">{player.type}</TableCell>
            <TableCell align="right">{player.totalVisits}</TableCell>
            <TableCell align="right">
              {date(player.createdAt)}
              <br />
              {time(player.createdAt)}
            </TableCell>
            <TableCell align="right">
                <IconButton aria-controls="player-actions" aria-haspopup="true" onClick={(event) => handleClick(event, player.id)}>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>);
        })
        : <TableRow style={{ height: 73 * props.emptyRows }}>
            <TableCell colSpan={11} align="center">
              {'Data not loaded'}
            </TableCell>
          </TableRow>
        }
        {
          ((props.emptyRows > 0) && (players.length < props.rowsPerPage) && (players.length !== 0)) && (
            <TableRow style={{ height: 73 * props.emptyRows }}>
              <TableCell colSpan={11} />
            </TableRow>
          )
        }
        </TableBody>
        <Menu
          id="tower-actions"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <VisibilityIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="View" />
          </MenuItem>
        </Menu>
    </React.Fragment>
  );
}

PlayersTable.propTypes = {
  data: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  emptyRows: PropTypes.number.isRequired,
  isSelected: PropTypes.func.isRequired,
  handleRowClick: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  numSelected: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
};
